<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm8>
        <p class="text-truncate">{{ broadcast.name }}</p>
      </v-flex>
      <v-flex xs12 sm4 text-xs-right>
        <v-btn
          v-if="draft"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('editBroadcast', broadcast, isSaveOnly)"
        >
          <em class="fas fa-pencil-alt" />
        </v-btn>
        <v-btn
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('copyBroadcast', broadcast, draft ? 'draft' : 'sent')"
        >
          <em class="fas fa-copy" />
        </v-btn>
        <v-btn
          v-if="draft"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('deleteBroadcast', broadcast.id, broadcast.name, isSaveOnly)"
        >
          <em class="fas fa-trash" />
        </v-btn>
        <v-btn
          v-else
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('viewBroadcast', index)"
        >
          <em class="fas fa-eye" />
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4 class="grey--text text--lighten-1 caption">
        <div>
          {{ broadcast.createdtime | DateFormat('DD/MM/YYYY hh:mm A') }}
        </div>
        <div>{{ $t('Created by') + ' ' }} {{ adminName }}</div>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-left text-sm-right">
        <v-chip v-if="broadcast.isschedule" color="info" text-color="white" small disabled>
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          {{ broadcast.scheduletime | DateFormat('DD/MM/YYYY hh:mm A') }}
        </v-chip>
        <v-chip v-else-if="draft" color="grey" text-color="white" small disabled>{{
          $t('Draft')
        }}</v-chip>
        <template v-if="lineGroup">
          <v-chip v-if="parseFloat(broadcast.reach) > 0" color="#A0E83D" text-color="white" small>{{
            $t('Reach') + ' ' + broadcast.reach + ' ' + $t('users')
          }}</v-chip>
          <v-chip v-if="parseFloat(broadcast.no_reach) > 0" color="red" text-color="white" small>{{
            $t('Unreach') + ' ' + broadcast.no_reach + ' ' + $t('users')
          }}</v-chip>
        </template>
        <template v-else>
          <v-chip
            v-if="parseFloat(broadcast.no_reach) > 0 && selectedBot.type == 'jamsai'"
            color="#A0E83D"
            text-color="white"
            small
            disabled
            @click="jamsaiReachBroadCast()"
            >{{ $t('Reach') + ' ' + broadcast.no_reach + ' ' + $t('users') }}</v-chip
          >
          <v-chip
            v-else-if="parseFloat(broadcast.no_reach) > 0"
            color="#A0E83D"
            text-color="white"
            small
            @click="$emit('onShowBroadcastHistory', { type: 'reach', broadcast: broadcast })"
            >{{ $t('Reach') + ' ' + broadcast.no_reach + ' ' + $t('users') }}</v-chip
          >
          <v-chip
            v-if="parseFloat(broadcast.no_unreach) > 0"
            color="red"
            text-color="white"
            small
            @click="$emit('onShowBroadcastHistory', { type: 'unreach', broadcast: broadcast })"
            >{{ $t('Unreach') + ' ' + broadcast.no_unreach + ' ' + $t('users') }}</v-chip
          >
        </template>
      </v-flex>
      <v-dialog
        v-if="showLog"
        v-model="showLog"
        persistent
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card class="pb-4">
          <v-card-title class="ma-0">
            <v-spacer />
            <v-btn icon small :loading="loading" @click="showLog = false"
              ><v-icon>close</v-icon></v-btn
            >
          </v-card-title>
          <BroadcastLog :broadcast_id="broadcast.id" />
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import BroadcastLog from './BroadcastLog'
export default {
  components: {
    BroadcastLog
  },
  props: ['broadcast', 'index', 'draft', 'isSaveOnly', 'lineGroup'],
  data() {
    return {
      showLog: false
      //   broadcast: this.value,
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    adminName() {
      var vm = this
      if (vm.broadcast.createdby) {
        if (/^\d+$/.test(vm.broadcast.createdby)) {
          var result = vm.$store.state.facebook_users_name.find(
            (el) => el.id == vm.broadcast.createdby
          )
          if (result) return result.name || ''
          else return ''
        } else {
          return vm.broadcast.createdby
        }
      } else return ''
    }
  },
  mounted() {
    if (this.broadcast.createdby && /^\d+$/.test(this.broadcast.createdby))
      this.getFbName(this.broadcast.createdby)
  },
  methods: {
    jamsaiReachBroadCast() {
      this.showLog = true
    },
    async getFbName(userid) {
      var vm = this
      var fbusersname = vm.$store.state.facebook_users_name
      if (!fbusersname.some((el) => el.id == userid))
        var result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot.page_access_token}`
        )
      if (result) {
        vm.$store.state.facebook_users_name.push(result.data)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastItem.vue